import { Box, Button, GridItem, Heading, Image, SimpleGrid, Text } from '@chakra-ui/react'
import React from 'react'
import { LuArrowRight } from 'react-icons/lu'

const BlogShortcut = () => {

    const ArrayOfArticles = [
        {
            title: "Partenariats",
            description: "Découvrez nos nouveaux partenariats et collaborations passionnants qui renforcent notre engagement envers l'excellence.",
            image: require('../../../assets/Blog/1.jpg')
        },
        {
            title: "Partenariats",
            description: "Découvrez nos nouveaux partenariats et collaborations passionnants qui renforcent notre engagement envers l'excellence.",
            image: require('../../../assets/Blog/1.jpg')
        },
        {
            title: "Partenariats",
            description: "Découvrez nos nouveaux partenariats et collaborations passionnants qui renforcent notre engagement envers l'excellence.",
            image: require('../../../assets/Blog/1.jpg')
        },
        {
            title: "Partenariats",
            description: "Découvrez nos nouveaux partenariats et collaborations passionnants qui renforcent notre engagement envers l'excellence.",
            image: require('../../../assets/Blog/1.jpg')
        },
    ]
  return (
    <Box
    px={{ md: 'inherit', '2xl': "19%", base: 4 }}
    py={{'2xl': 20, base: 10}}
    >
        <Box w={'full'}>
            <Heading fontSize={{ '2xl': 'xl', md: 'xl', base: 'md' }} 
                bgGradient={'to-r'}
                gradientFrom={'blue.500'}
                gradientTo={'purple.600'}
                bgClip={'text'}
                fontFamily={'Outfit'} textTransform={'uppercase'}>
                Articles
            </Heading>
            <Heading
                mt={{'2xl': 8, base: 2}}
                fontWeight={600}
                letterSpacing={-1.8}
                fontFamily={'Poppins'}
                fontSize={{ '2xl': '7xl', md: '3xl', base: '2xl' }}
                lineHeight={1.2}
            >
                Actualites
            </Heading>



            <SimpleGrid columns={4} gap={8} mt={20}>
                {ArrayOfArticles.map((article, index) => (
                    <GridItem key={index}>
                        <Image src={article.image} w={'full'} h={'350px'} rounded={20} />
                        <Box mt={2}>
                            <Heading fontFamily={'Onest'} color={'blue.500'} letterSpacing={-0.5} fontSize={'md'}>
                                {article.title}
                            </Heading>
                            <Text fontFamily={'Onest'} letterSpacing={-0.5} mt={2}>
                                {article.description}
                            </Text>
                        </Box>

                    <Button rounded={'full'} mt={4}>
                      <LuArrowRight /> Lire l'article
                    </Button>
                </GridItem>
            ))}
            </SimpleGrid>
        </Box>
    </Box>
  )
}

export default BlogShortcut